import assets from "../../assets/index";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { StyledSplashScreen, StyledBG, StyledTextIntro } from "./styles";
import { useBookingEngine } from "../../context/BookingEngineContext";
import { LoaderComponent } from "../../components/";
import { isAuthenticated } from "../../utils/isAuthenticated";

const SplashScreen = () => {
  const { bookingEngineData } = useBookingEngine();
  const navigate = useNavigate();
  const [hostLogo, setHostLogo] = useState<string | null>(null);
  //const hostLogo = bookingEngineData?.logoImage?.urls?.big ?? assets.Logo;

  const mainBg = assets.SkylineImg;
  const [greeting, setGreeting] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/home");
    }
  });
  useEffect(() => {
    const currentHour = new Date().getHours();

    if (currentHour >= 6 && currentHour < 12) {
      setGreeting("Rise and shine ☀️");
      setQuestionText("Let's seize the day.");
    } else if (currentHour >= 12 && currentHour < 18) {
      setGreeting("Good afternoon ☀️");
      setQuestionText("How are You?");
    } else if (currentHour >= 18 && currentHour < 21) {
      setGreeting("Good evening, adventurer!");
      setQuestionText("Ready to unwind?");
    } else {
      setGreeting("Good night, traveller!");
      setQuestionText("Relax and unwind!");
    }

    const timer = setTimeout(() => {
      navigate("/login");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    if (bookingEngineData) {
      setHostLogo(bookingEngineData?.logoImage?.urls?.big ?? assets.Logo);
      setLoading(false);
    }
  }, [bookingEngineData]);

  const backgroundImage = mainBg;

  if (loading) {
    return (
      <StyledSplashScreen>
        {" "}
        <LoaderComponent content="Loading ..." />
      </StyledSplashScreen>
    );
  }
  return (
    <StyledSplashScreen>
      <img
        className="logo"
        src={hostLogo ?? undefined}
        alt={`${bookingEngineData?.name || "Jurny"} logo`}
        loading="lazy"
      />

      <StyledTextIntro>
        <p>{greeting}</p>
        <h3>{questionText}</h3>
      </StyledTextIntro>

      <StyledBG loading="lazy" src={backgroundImage} alt="" />
    </StyledSplashScreen>
  );
};

export default SplashScreen;
